import { IYearMonth } from '@/coreDomainsModule/date';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { ForecastService } from '@/coreDomainsModule/services/forecastService';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * 内示を操作するためのサービス
 */
export class AnnounceService {
  /**
   * setAnnounceが存在する時、baseAnnounceの内示をsetAnnounceの内示で上書きする
   * @param baseAnnounce - 基準となる内示
   * @param setAnnounce - 上書きする内示
   * @param manageInitiatedForecastDate - 内示情報の管理開始日時(仕入先内示作成日)
   * @returns 上書きした内示
   */
  public static setSupplierAnnounce(
    baseAnnounce?: IAnnounce[],
    setAnnounce?: IAnnounce[],
    manageInitiatedForecastDate?: Date
  ): IAnnounce[] {
    // 仕入先内示作成月の設定
    // TODO: とりあえず一旦当月を突っ込む
    const saveDate = DateService.convertDateToIDate(!manageInitiatedForecastDate ? new Date() : manageInitiatedForecastDate);
    // 仕様が不明瞭なため、とりあえずbaseAnnounceを受け取っているが現状は特に使っていない
    if (!setAnnounce) return [];
    const output: IAnnounce[] = [];
    ForecastService.setAnnounceYearMonth(output, new Date()); // 今月を基準に、4ヶ月分の枠を作成する
    const saveYearMonth: IYearMonth = {
      year: saveDate.year,
      month: saveDate.month,
    };

    setAnnounce.forEach((announce) => {
      output.forEach((item) => {
        if (DateService.equalYearMonthInfo(announce, item)) {
          item.amount = announce.amount;
          item.manageInitiatedYearMonth = saveYearMonth;
        }
      });
    });
    return output;
  }

  /**
   * updateAnnounceが存在する時、baseAnnounceの内示をupdateAnnounceの内示で上書きする(和集合を作る)
   * updateAnnounceは必ずoutputに含まれるように作成
   * @param baseAnnounce - 基準となる内示
   * @param updateAnnounce - 上書きする内示
   * @returns 上書きした内示
   */
  public static unionCustomerAnnounce(baseAnnounce: IAnnounce[], updateAnnounce?: IAnnounce[]): IAnnounce[] {
    if (!updateAnnounce) return [];
    const output: IAnnounce[] = simpleCopy(baseAnnounce);
    updateAnnounce.forEach((announce) => {
      let existAnnounce = false;
      baseAnnounce.forEach((base, index) => {
        if (DateService.equalYearMonthInfo(announce, base)) {
          output[index].amount = announce.amount;
          existAnnounce = true;
        }
      });
      if (!existAnnounce) {
        output.push(announce);
      }
    });
    return output;
  }

  /**
   * 内示履歴情報を年月で昇順、受領年月で降順にソートする
   * @param announces - 内示情報
   */
  public static sortAnnounceHistories = (announces: IAnnounce[]) => {
    return announces.sort((a, b) => {
      // まずyearで昇順比較
      if (a.year !== b.year) {
        return a.year - b.year;
      }

      // 次にmonthで昇順比較
      if (a.month !== b.month) {
        return a.month - b.month;
      }

      // manageInitiatedYearMonthで降順比較
      const aManageYear = a.manageInitiatedYearMonth?.year ?? 0;
      const aManageMonth = a.manageInitiatedYearMonth?.month ?? 0;
      const bManageYear = b.manageInitiatedYearMonth?.year ?? 0;
      const bManageMonth = b.manageInitiatedYearMonth?.month ?? 0;

      if (aManageYear !== bManageYear) {
        return bManageYear - aManageYear; // 降順
      }

      return bManageMonth - aManageMonth; // 降順
    });
  };
}
